export const environment = {
  production: false,
  server: 'https://test.portale.winehunter.it/api',
  serverV2: 'https://test.portale.winehunter.it/api/v2'
};
